import { makeAutoObservable } from 'mobx';
import memoize from 'lodash/memoize';

import MediaSubFormat, { MediaSubFormatModel } from '../entity/MediaSubFormat';

class MediaSubFormatRepository {
  mediaSubFormats: Nullable<MediaSubFormat[]> = null;

  constructor() {
    makeAutoObservable(this, {
      findMediaSubFormatById: false,
    });

    this.findMediaSubFormatById = memoize(this.findMediaSubFormatById);
  }

  initMediaSubFormats(mediaSubFormatsData: { id: number; r: Nullable<number> }[]) {
    this.mediaSubFormats = mediaSubFormatsData.map((d) => new MediaSubFormat(d as MediaSubFormatModel));
  }

  findMediaSubFormatById = (id: number): Nullable<MediaSubFormat> => {
    if (!this.mediaSubFormats) {
      return null;
    }

    return this.mediaSubFormats.find((msf) => msf.id === id) ?? null;
  };
}

export const mediaSubFormatRepository = new MediaSubFormatRepository();
